// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial state and reducer maps
import initialState from './initialState'
import { reducers as authReducers } from 'fc-authenticated-user'
import userReducers from 'fc-users/src/reducers'

// Controller
import controller from 'fc-ctrl-users'

// Exports
export default createReducer(initialState, {
  ...controller.reducers,
  ...authReducers,
  ...userReducers,
})
